import styled from "styled-components";

export const StyledOAutorze = styled.div`
  a {
    color: #ffcc00ff;
  }
`;
